'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useReducer, useState } from 'react';
import { Logger } from '../../lib/logger';
import { reducer } from './reducer';
import initialState from './state';
import { SET_PAGE } from './actions';
import { noop } from 'lodash';
export const PageContext = createContext({
    usePageState: () => Object.freeze(initialState),
    setPage: (payload) => { },
    setHandlers: (handlers) => { },
    setPageData: (data) => { },
    onPageAction: (action, data) => { },
    usePageData: (noData) => ({}),
    setResponseHandlers: (handlers) => { }
});
export const PageProvider = ({ children, pagePathnameHook, redirectHandler = noop, onChange = noop }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [pageData, setPageData] = useState(null);
    const [handlers, setHandlers] = useState({});
    const [responseHandlers, setResponseHandlers] = useState({});
    const pathname = pagePathnameHook();
    useEffect(() => {
        setPageData(null);
    }, [pathname]);
    const usePageState = () => {
        return state;
    };
    const usePageData = () => {
        return pageData || {};
    };
    const handleResponse = async (action, response) => {
        const responseHandler = responseHandlers[action];
        if (responseHandler) {
            const path = await responseHandler(response);
            if (typeof path !== 'string') {
                Logger.error('Response handler must return a string');
            }
            else {
                redirectHandler(path);
            }
        }
    };
    const handlePageAction = async (action, data) => {
        onChange({ loading: true });
        const handler = handlers[action];
        if (!handler) {
            Logger.error(`Handler for action ${action} not found`);
            onChange({ loading: false });
            return;
        }
        try {
            const response = await handler(data || pageData);
            Logger.log('[PageProvider] handlePageAction.response', JSON.stringify(response, null, 2));
            onChange({ loading: false });
            handleResponse(action, response);
        }
        catch (e) {
            Logger.error(e);
            onChange({ loading: false });
        }
    };
    return (_jsx(PageContext.Provider, { value: {
            usePageState,
            setPage: (payload) => dispatch({ type: SET_PAGE, payload }),
            setHandlers,
            setPageData,
            onPageAction: handlePageAction,
            usePageData,
            setResponseHandlers
        }, children: children }));
};
